import React from 'react';
import { useSonTranslation } from '../../../../../../translation/useSonTranslation';
import { PersonInformation } from '../../../../PersonInformation';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import { PersonInformationProps } from '../../../../PersonInformation/PersonInformation';
import { ContextMenu, ContextMenuButton } from '../../../../../../_lib/components/ContextMenu';
import Btn, { BtnModifier } from '../../../../Btn';
import { Icons } from '../../../../../atoms/SVG';

type PersonInformationRequiredProps = Pick<
  PersonInformationProps,
  'emailLink' | 'profileImageUrl' | 'profileLink' | 'orgUnit' | 'phoneLink'
>;

type PersonPreview = PersonInformationRequiredProps & {
  id: string;
  reset: (userId: string) => void;
  moveUp?: () => void;
  moveDown?: () => void;
  buttonTooltipPlacement?: TooltipPlacement;
  ariaControls?: string;
};
export function PersonPreview({
  id,
  profileImageUrl,
  emailLink,
  reset,
  moveUp,
  moveDown,
  profileLink,
  phoneLink,
  orgUnit,
  buttonTooltipPlacement,
  ariaControls,
}: PersonPreview) {
  const { t } = useSonTranslation('FormsComboBox');

  let btnModifier = [BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT];

  return (
    <div className="person-preview">
      <div className="person-preview__wrapper">
        <div className="person-preview__content">
          <PersonInformation
            key={id}
            profileImageUrl={profileImageUrl}
            profileLink={profileLink}
            phoneLink={phoneLink}
            emailLink={emailLink}
            orgUnit={orgUnit}
            profileName={profileLink?.name}
          />
        </div>
        <>
          {moveUp || moveDown ? (
            <ContextMenu
              tooltipText={t('personPreview.contextButtonText', { item: profileLink?.name || '' })}
              tooltipPlacement={TooltipPlacement.TOP}
            >
              <ContextMenuButton
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();

                  if (moveUp) {
                    moveUp();
                  }
                }}
                disabled={!moveUp}
              >
                {t('personPreview.moveUpButtonText')}
              </ContextMenuButton>
              <ContextMenuButton
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();

                  if (moveDown) {
                    moveDown();
                  }
                }}
                disabled={!moveDown}
              >
                {t('personPreview.moveDownButtonText')}
              </ContextMenuButton>
              <ContextMenuButton
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();

                  reset(id);
                }}
              >
                {t('personPreview.removeButtonText')}
              </ContextMenuButton>
            </ContextMenu>
          ) : (
            <Btn
              modifier={btnModifier}
              svgSpriteId={Icons.DELETE_X_SMALL}
              ariaControls={ariaControls}
              type="button"
              text={t('personPreview.deleteButtonText', { item: profileLink?.name || '' })}
              titleText={t('personPreview.deleteButtonText', { item: profileLink?.name || '' })}
              hiddenText
              tooltipPlacement={buttonTooltipPlacement ? buttonTooltipPlacement : TooltipPlacement.LEFT}
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();

                reset(id);
              }}
            />
          )}
        </>
      </div>
    </div>
  );
}
